/**
 * Marketing pages ship as pre-built HTML (see scripts/ssg.mjs) that React hydrates.
 * While hydrating, the first client render must produce exactly the server markup,
 * so components use this flag to skip effects that would change what is already on screen.
 */
let hydrating = false;

export const isHydrating = () => hydrating;

export function setHydrating(value: boolean) {
  hydrating = value;
}
